// Reminder offsets are stored as "minutes before the event start".
export const REMINDER_PRESETS: { label: string; minutes: number }[] = [
  { label: "At start", minutes: 0 },
  { label: "5 min", minutes: 5 },
  { label: "15 min", minutes: 15 },
  { label: "30 min", minutes: 30 },
  { label: "1 hour", minutes: 60 },
  { label: "2 hours", minutes: 120 },
  { label: "4 hours", minutes: 240 },
  { label: "1 day", minutes: 1440 },
  { label: "2 days", minutes: 2880 },
  { label: "1 week", minutes: 10080 },
];

export const REMINDER_UNITS: {
  value: "min" | "hour" | "day" | "week";
  label: string;
  minutes: number;
}[] = [
  { value: "min", label: "min", minutes: 1 },
  { value: "hour", label: "hours", minutes: 60 },
  { value: "day", label: "days", minutes: 1440 },
  { value: "week", label: "weeks", minutes: 10080 },
];

/** "1 hour", "30 min", "2 days"… for a minutes-before offset. */
export function reminderLabel(mins: number): string {
  if (mins <= 0) return "At start";
  // Deliberately excludes a `1`/"min" divisor: since 1 divides every integer,
  // including it here would always match before the loop could exit, leaving
  // the plain-minutes fallback below unreachable. A value that isn't a whole
  // number of hours/days/weeks (e.g. a custom "45 min" reminder) falls
  // through to that fallback instead.
  for (const [u, name] of [
    [10080, "week"],
    [1440, "day"],
    [60, "hour"],
  ] as const) {
    if (mins % u === 0) {
      const n = mins / u;
      return `${n} ${name}${n === 1 ? "" : "s"}`;
    }
  }
  return `${mins} min`;
}
